<iframe class="wsbiframe" #wsbiframe>
</iframe>

<ng-template cdk-portal #loadingTemplate>
  <div style="margin: 0px auto; align-content: center; text-align: center; margin-top: 110px">
    <img src="assets/images/loader.gif"/>
  </div>
</ng-template>

